// Глобальный сервис для показа уведомлений
class NotificationService {
  private listeners: Array<(message: string, type: 'success' | 'error' | 'info') => void> = []

  subscribe(listener: (message: string, type: 'success' | 'error' | 'info') => void) {
    this.listeners.push(listener)
    return () => {
      const index = this.listeners.indexOf(listener)
      if (index > -1) {
        this.listeners.splice(index, 1)
      }
    }
  }

  success(message: string) {
    console.log('NotificationService.success:', message)
    this.listeners.forEach(listener => listener(message, 'success'))
  }

  error(message: string) {
    console.log('NotificationService.error:', message)
    this.listeners.forEach(listener => listener(message, 'error'))
  }

  info(message: string) {
    console.log('NotificationService.info:', message)
    this.listeners.forEach(listener => listener(message, 'info'))
  }
}

export const notificationService = new NotificationService()